// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.editor-word-list-word-container{
  background: rgba(214, 251, 252, 0.233);
  margin-left: 5px;
  margin-right:5px;
}

.editor-word-list-word-container:hover{
  background: white;
}

.word-list-word .found {
  opacity: .5;
}

`, "",{"version":3,"sources":["webpack://./src/Components/Games/WordSearch/WordListWord/WordListWord.css"],"names":[],"mappings":"AAAA;EACE,sCAAsC;EACtC,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb","sourcesContent":[".editor-word-list-word-container{\n  background: rgba(214, 251, 252, 0.233);\n  margin-left: 5px;\n  margin-right:5px;\n}\n\n.editor-word-list-word-container:hover{\n  background: white;\n}\n\n.word-list-word .found {\n  opacity: .5;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
